export type SelectOption = {
  value: string
  label: string
}

export type SelectPreviewState =
  | 'default'
  | 'focused'
  | 'filled'
  | 'disabled'
  | 'error'
  | 'expanded'
  | 'multiple-options'
  | 'with-icon'
  | 'with-tooltip'
  | 'optional'
  | 'with-info'

export const SELECT_PREVIEW_STATES: SelectPreviewState[] = [
  'default',
  'focused',
  'filled',
  'disabled',
  'error',
  'expanded',
  'multiple-options',
  'with-icon',
  'with-tooltip',
  'optional',
  'with-info',
]

export const SELECT_PREVIEW_STATE_LABELS: Record<SelectPreviewState, string> = {
  default: 'Default',
  focused: 'Focused',
  filled: 'Filled',
  disabled: 'Disabled',
  error: 'Error',
  expanded: 'Expanded',
  'multiple-options': 'Multiple options',
  'with-icon': 'With icon',
  'with-tooltip': 'With tooltip',
  optional: 'Optional',
  'with-info': 'With info',
}

export const SELECT_DEMO_LABEL = 'Preferred time'

export const SELECT_DEMO_PLACEHOLDER = 'Select'

export const SELECT_DEMO_OPTIONS: SelectOption[] = [
  { value: '1:00 PM', label: '1:00 PM' },
  { value: '2:00 PM', label: '2:00 PM' },
  { value: '3:00 PM', label: '3:00 PM' },
  { value: '4:00 PM', label: '4:00 PM' },
  { value: '4:30 PM', label: '4:30 PM' },
  { value: '5:00 PM', label: '5:00 PM' },
  { value: '5:30 PM', label: '5:30 PM' },
  { value: '6:00 PM', label: '6:00 PM' },
]

export const SELECT_DEMO_FILLED_VALUE = '2:00 PM'

export const SELECT_DEMO_MULTIPLE_VALUES = ['2:00 PM', '4:00 PM', '5:00 PM']

export const SELECT_DEMO_ERROR_MESSAGE = 'Error description'

export const SELECT_DEMO_INFO_MESSAGE = 'Info text'

export type SelectProps = {
  label?: string
  placeholder?: string
  options?: SelectOption[]
  value?: string | string[]
  defaultValue?: string | string[]
  multiple?: boolean
  disabled?: boolean
  error?: boolean
  helperText?: string
  optional?: boolean
  showTooltip?: boolean
  leadingIcon?: 'clock'
  className?: string
  /** dark-mode palette. */
  darkMode?: boolean
  /** Static visual state for the design-system showcase only. */
  previewState?: SelectPreviewState
  onChange?: (value: string | string[]) => void
}
